
import React from 'react';

const CreatorProfile: React.FC = () => {
  return (
    <section className="py-24 bg-white overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col lg:flex-row gap-16 items-center">
          <div className="flex-1 order-2 lg:order-1">
             <div className="relative">
                <div className="grid grid-cols-2 gap-4">
                  <img
                    src="https://images.unsplash.com/photo-1515377905703-c4788e51af15?auto=format&fit=crop&q=80&w=600"
                    className="rounded-2xl shadow-lg mt-12 aspect-[4/5] object-cover"
                    alt="Wellness Content Creator"
                  />
                  <img
                    src="https://images.unsplash.com/photo-1544367567-0f2fcb009e0b?auto=format&fit=crop&q=80&w=600"
                    className="rounded-2xl shadow-lg aspect-[4/5] object-cover"
                    alt="Mindfulness Content Creation"
                  />
                </div>
                <div className="absolute -bottom-8 -right-8 bg-[#341368] text-white p-6 rounded-2xl shadow-xl max-w-[240px]">
                  <p className="text-lg font-bold">"I love that I just focus on creating great content. No need to manage a public profile!"</p>
                  <p className="text-sm text-purple-300 mt-4">— Maya, Wellness Creator</p>
                </div>
             </div>
          </div>

          <div className="flex-1 order-1 lg:order-2 space-y-8">
            <h2 className="text-4xl font-extrabold text-gray-900">Who we're looking for</h2>
            <p className="text-lg text-gray-600">We value authenticity and positive energy. Since this is a production role, we're looking for creators who are passionate about wellness, self-improvement, and empowering others.</p>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              {[
                "Passionate about personal growth",
                "Comfortable & natural on camera",
                "Good lighting & phone quality",
                "No prior marketing experience required",
                "Consistent content delivery",
                "Creative eye for wellness trends"
              ].map((item, idx) => (
                <div key={idx} className="p-4 bg-gray-50 rounded-xl border border-gray-100 flex items-center gap-3">
                  <div className="w-2 h-2 rounded-full bg-purple-600" />
                  <span className="font-medium text-gray-700">{item}</span>
                </div>
              ))}
            </div>

            <div className="p-6 bg-purple-50 rounded-2xl border border-purple-100">
               <p className="text-purple-800 font-bold text-center text-xl">
                 No social media following required. We only care about your content.
               </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CreatorProfile;
